import { useEffect } from "react";
import { redirectToCanonicalApp } from "@/lib/canonical-host";

/** White-label event domains have no CMS routes — send operators to aivoryems.com. */
export default function OperatorCanonicalRedirect() {
  useEffect(() => {
    redirectToCanonicalApp(window.location.pathname, window.location.search);
  }, []);

  return (
    <div className="min-h-screen grid place-items-center px-6 text-center" style={{ color: "var(--text-secondary)" }}>
      <p className="text-sm font-mono">Redirecting to sign in…</p>
    </div>
  );
}
